// components/Composite/ImageText/ImageText.js
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '../../Atoms';
import { RawHtml } from '../../Utilities';

const ImageText = ({ value = {} }) => {
  const { reverse = false, image, text, sectionWidth = 'section-default-width' } = value;

  if (!image && !text) return null;

  return (
    <section className={`section ${sectionWidth}`}>
      <div className="section__inner">
        <div className="section__body">
          <div className="block">
            <div className="block__body">
              <div className={reverse ? 'media-object media-object-reverse' : 'media-object'}>

                {image && (
                  <div className="media-object__media">
                    <div className="media-element media-element-horizontal">
                      <Image image={image} fit="contain" />
                    </div>
                  </div>
                )}

                {text && (
                  <div className="media-object__body">
                    <div className="content-element">
                      <RawHtml html={text} />
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ImageText.propTypes = {
  value: PropTypes.shape({
    reverse: PropTypes.bool,
    image: PropTypes.object,
    text: PropTypes.string,
    sectionWidth: PropTypes.string,
  }),
};

export default ImageText;